module.exports = __webpack_public_path__ + "img/C2M智能定制解决方案.e5786c29.png";